const ImgTimeValues = [
  { name: "ساعت", value: "hour" },
  { name: "روز", value: "day" },
  { name: "هفته", value: "week" },
  { name: "ماه", value: "month" },
  { name: "سال", value: "year" }
];
export default ImgTimeValues;